import actions from './actions'

const link = {
  state: null,
  mutations: null,
  actions
}

export default link



// WEBPACK FOOTER //
// ./src/store/link/index.js